import { render, staticRenderFns } from "./Parent_calculate.vue?vue&type=template&id=6a179c16&scoped=true"
import script from "./Parent_calculate.vue?vue&type=script&lang=js"
export * from "./Parent_calculate.vue?vue&type=script&lang=js"
import style0 from "./Parent_calculate.vue?vue&type=style&index=0&id=6a179c16&prod&lang=css"
import style1 from "./Parent_calculate.vue?vue&type=style&index=1&id=6a179c16&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a179c16",
  null
  
)

export default component.exports